import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import isEmpty from 'lodash-es/isEmpty';

/**
 * Determines if the given value is a LinkFieldValue.
 *
 * @param value - The value to check.
 * @returns True if the value is a LinkFieldValue, false otherwise.
 */
export const isLinkFieldValue = (value: unknown): value is LinkFieldValue => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'href' in value &&
    !isEmpty(value.href) &&
    'linktype' in value &&
    !isEmpty(value.linktype)
  );
};
